import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { QsChile } from '@/components/Rankings'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'

const IndexPage = () => (
  <Layout>
    <SEO
      title="QS LatAm: el club de las 40"
      keywords={[
        `La Tercera`,
        `Ranking QS Latam`,
        `Universidades Chilenas en el extranjero`,
      ]}
    />
    <Content>
      <h1>
        QS LatAm: <strong>el club de las 40</strong>{' '}
      </h1>
      <Columns>
        <p>
          A nivel nacional, son 40 universidades las que aparecen en el ranking
          QS Latin America University, nueve de ellas están dentro del Top 50.
          Tras la Católica (1) y la Chile (3), se encuentran las universidades
          de Concepción (11), USACh (15), Católica de Valparaíso (22), Adolfo
          Ibáñez (24), Diego Portales (31), Santa María (34) y Austral (37).
        </p>
        <p>
          Las posiciones alcanzadas por las universidades reflejan el desempeño
          en ocho indicadores, dos de los cuales representan el 50% de la
          posición en el ranking. Se trata de los resultados de las dos
          encuestas de reputación: a académicos, a quienes se les pregunta sobre
          las instituciones que consideran de excelencia en investigación, y a
          empleadores, quienes responden por aquellas que tienen los mejores
          egresados.
        </p>
        <p>
          La UC y la Chile empatan con 100 puntos en ambas encuestas. En el
          tercer lugar del prestigio académico se instalan la USACh, tras ella
          están las universidades de Concepción (4), Católica de Valparaíso (5),
          Austral (6), Adolfo Ibáñez (7), Diego Portales (8), de los Andes (9),
          de Talca y Santa María empatan en la décima posición.
        </p>
        <p>
          Entre empleadores, es la Adolfo Ibáñez la que se mantiene en la
          tercera posición. Le siguen, la USACh (4), de Concepción (5), Santa
          María (6), Diego Portales (7), Católica de Valparaíso (8), de los
          Andes (9) y del Desarrollo (10).
        </p>
        <p>
          La U. Diego Portales destaca como líder en las citaciones por papers,
          a ella se suman la de Antofagasta (2), de La Serena (3), del
          Desarrollo (4), de Magallanes (5), Santa María (6), Católica (7), de
          Chile (8), Católica del Norte (9) y Andrés Bello (10). Mientras que en
          publicaciones por académico la 10 primeras son: la Chile (1), La
          Frontera (2), Católica (3), Católica de Valparaíso (4), de Tarapacá
          (5), Austral (6), de La Serena (7), de Concepción (8), de Talca (9) y
          Católica del Norte (10).
        </p>
      </Columns>
      <QsChile />
    </Content>
    <Summary />
  </Layout>
)

export default IndexPage
